import { Component } from '@angular/core';

@Component({
    selector: 'structure-root',
    templateUrl: './structure.html',
})
export class StructureComponent { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/structure.component.ts